import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

/** Route guard: sends signed-out visitors to the login page and remembers where they were going. */
export function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
}
